import CustomerInvoicesHtml from './customer.invoices.html';

export function CustomerInvoicesDirective () {
  return {
    controller: 'CustomerInvoicesCtrl',
    restrict: 'E',
    templateUrl: CustomerInvoicesHtml,
    scope: {
      customer: '=',
      invoices: '=',
      statusTypes: '='
    }
  }
}